<template>
  <Modal  v-model="show" v-bind="$attrs">
    <div slot="header">
      <slot name="header"></slot>
    </div>
    <slot></slot>
  </Modal>
</template>
<script>
export default {
  name: 'xw-modal',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (val) {
        if(!val){
          this.$emit('close')
        }
        this.$emit('change', val)
      }
    }
  },
}
</script>
<style lang="stylus" scoped>
>>>.ivu-modal-footer {
  display: none;
}

>>>.ivu-modal-body {
  padding: 0;
}
</style>
